// src/js/reducers/index.js
import * as types from "../constants/action-types";
import Sorter from '../utils/sorter';


export default function roleReducer(state = [], action) {
    switch (action.type) {
        
        case types.LOGOUT:
            return []
        case types.LOAD_ROLE_SUCCESS:

            return  Sorter.sort(action.roles, 'name');
        
        default:
            return state;
    };
};


